/** @jsx jsx */
import { css, jsx } from "@emotion/core"

export function Frame({
  children,
  className,
  minHeight,
}: {
  children: React.ReactNode
  className?: string
  minHeight?: number
}) {
  return (
    <div
      className={className}
      css={css`
        height: 100%;
        ${minHeight &&
        css`
          min-height: ${minHeight}px;
        `}
        display: flex;
        place-items: center;
        place-content: center;
        flex-direction: column;
      `}
    >
      {children}
    </div>
  )
}
